<template>
  <default-layout>
    <section slot="content">
      <v-container fluid>
        <template>
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
              <v-icon color="secondary">mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
        </template>

        <template v-if="productColor.product">
          <v-row justify="center">
            <v-col cols="12" md="8" xs="12">
              <v-row justify="center">
                <v-col cols="12" md="6" xs="12">
                  <!-- style="border: 0" outlined elevation="0" -->
                  <v-card outlined elevation="0">
                    <v-img
                      v-if="selectedImage"
                      :src="selectedImage"
                      loading="lazy"
                      :key="selectedImage"
                      height="auto"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="primary lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-sheet
                      class="mx-auto justify-center v-responsive"
                      max-width="800"
                    >
                      <v-slide-group
                        class="pa-0 ma-0"
                        show-arrows
                      >
                        <v-slide-item
                          v-for="obj in productColorImages"
                          v-if="obj.product_color_id == selectedProductColorId && obj.type == 'chico'"
                          :key="obj.id"
                          v-slot="{ active, toggle }"
                        >
                          <v-card
                            :style="[(obj.id == selectedImageSmallId) ? {'border': '#3ab1c7 solid'} : {'border': '0px'}]"
                            class="ma-3 justify-center pa-0 ma-2"
                            height="80"
                            width="80"
                            @click="toggle"
                          >
                            <v-img
                              :src="obj.image"
                              loading="lazy"
                              @click="selectSmallImage(obj)"
                            >
                            </v-img>
                          </v-card>
                        </v-slide-item>
                      </v-slide-group>

                    </v-sheet>
                  </v-card>
                </v-col>

                <v-col cols="12" md="6" xs="12">
                  <v-card class="pt-sm-12 pt-xs-2">
                    <v-card-title class="justify-center">
                      <div class="name-product text-center">{{ productColor.product.name }}</div>
                    </v-card-title>

                    <v-card-text>
                      <v-row
                        align="center"
                        class="mx-0"
                      >
                        <v-rating
                          :value="productColor.product.average_star ? productColor.product.average_star : 5"
                          color="secondary"
                          dense
                          half-increments
                          readonly
                          size="16"
                        ></v-rating>
                      </v-row>

                      <div class="my-3 product-name">{{ productColor.product.group }}</div>
                    </v-card-text>

                    <v-card-title class="mt-n8">
                      <v-row no-gutters>
                        <template v-if="productColor.product.off">
                          <v-col cols="6" sm="6" xs="6">
                            <v-card class="pa-0 ma-0 overline" style="border: 0px" outlined elevation="0">
                              Precio especial
                            </v-card>
                          </v-col>
                          <v-col cols="6" sm="6" xs="6">
                            <v-card class="pa-0 ma-0 text-right" style="border: 0" outlined elevation="0">
                              S/ {{ productColor.product.sale_price }}
                            </v-card>
                          </v-col>
                          <v-col cols="6" sm="6" xs="6">
                            <v-card class="pa-0 ma-0 overline" style="border: 0" outlined elevation="0">
                              Precio regular
                            </v-card>
                          </v-col>
                          <v-col cols="6" sm="6" xs="6">
                            <v-card class="pa-0 ma-0 mt-1 body-2 text-right" style="border: 0" outlined elevation="0">
                              S/ {{ productColor.product.regular_price }}
                            </v-card>
                          </v-col>
                          <v-col cols="6" sm="6" xs="6">
                            <v-card class="pa-0 ma-0 overline" style="border: 0" outlined elevation="0">
                              Descuento
                            </v-card>
                          </v-col>
                          <v-col cols="6" sm="6" xs="6">
                            <v-card class="pa-0 ma-0 text-right" style="border: 0" outlined elevation="0">
                              <v-chip
                                color="pink"
                                label
                                text-color="white"
                              >
                                <v-icon left>
                                  mdi-label
                                </v-icon>
                                - {{ productColor.product.off }}%
                              </v-chip>
                            </v-card>
                          </v-col>
                        </template>
                        <template v-else>
                          <v-col cols="6" sm="6" xs="6">
                            <v-card class="pa-0 ma-0 overline" style="border: 0" outlined elevation="0">
                              Precio
                            </v-card>
                          </v-col>
                          <v-col cols="6" sm="6" xs="6">
                            <v-card class="pa-0 ma-0 text-right" style="border: 0" outlined elevation="0">
                              S/ {{ productColor.product.regular_price }}
                            </v-card>
                          </v-col>
                        </template>
                      </v-row>
                    </v-card-title>

                    <template v-if="(productColors.length == 1 && productColors[0].color.name != 'NOT_COLOR') || productColors.length > 1">
                      <v-card-text>
                        <div class="text-left">
                          <v-col cols="6" sm="6" xs="6">
                            <v-card class="pa-0 ma-0 overline" style="border: 0" outlined elevation="0">
                              <b>COLOR:</b>
                            </v-card>
                          </v-col>
                          <template v-for="obj in productColors">
                            <v-btn
                              v-if="obj.color.name != 'NOT_COLOR'"
                              class="mx-2"
                              fab
                              dark
                              small
                              :color="obj.color.hexcolor"
                              :style="[ obj.id == selectedProductColorId ? {'border': '#3ab1c7 solid'} : {'border': '0px'}]"
                              @click="selectColor(obj.id)"
                            >
                            </v-btn>
                          </template>
                        </div>
                        <div class="text-left pt-0">
                          <v-col cols="6" sm="6" xs="6">
                            <v-card class="pa-0 ma-0 overline" style="border: 0" outlined elevation="0">
                              <b>TALLA:</b>
                            </v-card>
                          </v-col>
                          <template v-for="obj in productColorSizes" v-if="obj.product_color_id == selectedProductColorId">
                            <v-btn
                              v-if="obj.size.name != 'NOT_SIZE'"
                              :disabled="obj.disabled == 1"
                              class="ma-2"
                              outlined
                              color="indigo"
                              :style="[
                                obj.id == selectedProductColorSizeId ?
                                {'border': '#3ab1c7 solid'} :
                                (obj.disabled == 0 ? {'color': '#3f51b5!important'} : '')
                              ]"
                              @click="selectedProductColorSizeId = obj.id"
                            >
                              {{ obj.size.name }}
                            </v-btn>
                          </template>
                        </div>
                      </v-card-text>
                    </template>

                    <template v-if="(productColorSizes.length == 1 &&
                      productColorSizes[0].size.name == 'NOT_SIZE' &&
                      productColorSizes[0].disabled == 0) ||
                      (productColorSizes.length == 1 &&
                      productColorSizes[0].size.name != 'NOT_SIZE' &&
                      productColorSizes[0].disabled == 0)
                      ||  productColorSizes.length > 1">
                      <v-card-actions class="white justify-center">
                        <v-row row d-flex nowrap>
                          <v-col
                            cols="12"
                            sm="7"
                            xs="12"
                          >
                            <v-text-field
                              type="number"
                              min="1"
                              class="input-price"
                              outlined
                              dense
                              v-model="quantity"
                              disabled readonly
                            >
                              <template v-slot:prepend>
                                <v-btn style="top: -7px" :disabled="quantity == 1" @click="decrement">
                                  <v-icon center>
                                    remove
                                  </v-icon>
                                </v-btn>
                              </template>
                              <template slot="append-outer">
                                <v-btn style="top: -7px" @click="increment">
                                  <v-icon center>
                                    add
                                  </v-icon>
                                </v-btn>
                              </template>
                            </v-text-field>
                          </v-col>

                          <v-col
                            cols="12"
                            sm="5"
                            xs="12"
                            class="justify-center"
                          >
                            <v-btn :disabled="disabledSubmit" color="primary" class="btn-add-cart" elevation="2" @click="addProduct">
                              <v-icon left>shopping_cart</v-icon>
                              AGREGAR
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-actions>
                      <template v-if="$vuetify.breakpoint.xsOnly">
                        <v-card-actions class="white justify-center">
                          <v-row row d-flex nowrap>
                            <v-col
                              cols="12"
                              sm="12"
                              xs="12"
                              class="justify-center"
                            >
                              <v-btn
                                color="white--text"
                                style="font-size: 11px !important; background: #45c554"
                                elevation="2"
                                target="_blank"
                                :href="goWhatsapp()"
                                block
                              >
                                <v-icon left>mdi-whatsapp</v-icon>
                                COMPRAR POR WHATSAPP
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="productColorSizes.length != 0">
                        <v-col cols="12" sm="12" xs="12">
                          <v-card class="pa-0 ma-0 text-center" style="border: 0" outlined elevation="0">
                            <span>PRODUCTO SIN STOCK</span>
                          </v-card>
                        </v-col>
                      </template>
                    </template>

                    <v-card-title v-if="productColor.product.delivery_type.length > 0">MÉTODOS DE ENTREGA</v-card-title>

                    <template>
                      <v-list subheader two-line>
                        <v-list-item
                          v-for="obj in productColor.product.delivery_type"
                          :key="obj.id"
                        >
                          <v-list-item-avatar>
                            <v-icon
                              style="background-color: #3ab1c7"
                              color="white"
                              dark
                              v-text="obj.icon"
                            ></v-icon>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title v-text="obj.type"></v-list-item-title>
                            <v-list-item-subtitle class="text-wrap" v-text="obj.description"></v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-btn icon>
                              <v-icon color="grey lighten-1">mdi-information</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </template>

                  </v-card>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="8" xs="12">
              <v-expansion-panels multiple v-model="panel">
                <v-expansion-panel class="mb-8">
                  <v-expansion-panel-header class="tile" color="primary">
                    <b style="color: white">DETALLES</b>
                    <template v-slot:actions>
                      <v-icon color="white">
                        $expand
                      </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row dense align="center" justify="center">
                      <v-col cols="12">
                        <v-card flat>
                          <v-card-text 
                            class="v-card__text text-body-2" 
                            v-html="(productColor.product.description || '').split('\n').join('<br />')"
                          >
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>

            <!-- <v-col cols="12" md="8" xs="12">
              <v-expansion-panels multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header class="tile" color="primary">
                    <b style="color: white">MÁS INFORMACIÓN</b>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row dense align="center" justify="center">
                      <v-col cols="12">
                        <v-card flat>
                          <v-card-text class="ma-0 pa-0">
                            <template>
                              <v-simple-table>
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <th class="text-center">Desde</th>
                                      <th class="text-center">Hasta</th>
                                      <th class="text-center">Dias</th>
                                      <th class="text-center">Estado</th>
                                      <th class="text-center">Descripción</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td class="text-center">aaa aa</td>
                                      <td class="text-center">aaa aa</td>
                                      <td class="text-center">aaa aa</td>
                                      <td class="text-center">aaa aa</td>
                                      <td class="text-center">aaa aa</td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col> -->

          </v-row>
        </template>

        <template>
          <div class="text-center ma-2">
            <v-snackbar
              v-model="snackbar"
              :color="color"
              top
            >
              {{ text }}
              <template v-slot:action="{ attrs }">
                <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
                >
                  X
                </v-btn>
              </template>
            </v-snackbar>
          </div>
        </template>
      </v-container>
    </section>
  </default-layout>
</template>
<script>
  import axios from 'axios'
  import DefaultLayout from '@/layouts/DefaultLayout'
  import CartStore from '@/stores/Cart'
  import constants from '@/constants/index'

  export default {
    name: 'ProductDetail',
    components: {
      DefaultLayout
    },
    data () {
      return {
        productColor: {},
        productColors: [],
        productColorSizes: [],
        productColorImages: [],

        selectedProductColorId: null,
        selectedProductColorSizeId: null,

        selectedImage: null,
        selectedImageSmallId: 0,

        panel: [0],
        quantity: 1,
        snackbar: false,
        text: '',
        color: 'green',
        disabledSubmit: false
      }
    },
    computed: {
      breadcrumbs() {
        return [
          { text: 'INICIO', disabled: false, to: '/' },
          { text: this.$route.params.productName.toUpperCase(), disabled: true, href: 'breadcrumbs_link_2' }
        ];
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      getProductColor () {
        axios.get(process.env.DINO.PATH.GET_PRODUCT_DETAIL.replace(':productColorId', this.$route.params.productColorId))
        .then(response => {
          this.productColor = response.data;
        })
        .catch(err => {
        })
        .then(() => {
          this.getColors();
        });
      },

      getColors () {
        axios.get(process.env.DINO.PATH.GET_PRODUCT_COLORS.replace(':productId', this.$route.params.productId))
        .then(response => {
          this.productColors = response.data;
        })
        .catch(err => {
        })
        .then(() => {
          this.getImages();
          this.getSizes();
        });
      },

      getImages () {
        axios.get(process.env.DINO.PATH.GET_PRODUCT_IMAGES.replace(':productId', this.$route.params.productId))
        .then(response => {
          this.productColorImages = response.data;
        })
        .catch(err => {
        })
        .then(() => {
          this.selectColor(this.$route.params.productColorId);
        });
      },

      getSizes () {
        axios.get(process.env.DINO.PATH.GET_PRODUCT_SIZES.replace(':productId', this.$route.params.productId))
        .then(response => {
          this.productColorSizes = response.data;
        })
        .catch(err => {
        })
        .then(() => {
        });
      },

      increment () {
        this.quantity = this.quantity + 1;
      },

      decrement () {
        this.quantity = this.quantity - 1;
      },

      selectColor (productColorId) {
        this.selectedProductColorSizeId = null;
        this.selectedProductColorId = productColorId;
        this.selectImage(productColorId, 1);
      },

      selectSmallImage (productColorImage) {
        this.selectImage(productColorImage.product_color_id, productColorImage.order);
      },

      selectImage (productColorId, order) {
        const self = this;
        this.productColorImages.forEach(function(obj) {
          if (obj.product_color_id == productColorId && obj.order == order) {
            if (obj.type == constants.IMAGE_TYPE_SMALL) {
              self.selectedImageSmallId = obj.id;
            } else if (obj.type == constants.IMAGE_TYPE_LARGE) {
              self.selectedImage = obj.image;
            }
          }
        });
      },

      addProduct() {
        this.disabledSubmit = true;
        const notColor = (this.productColors.length == 1 && this.productColors[0].color.name == 'NOT_COLOR') ? true : false;
        if (!notColor) {
          if (this.selectedProductColorSizeId === null) {
            this.showMessage('¡Seleccionar talla por favor!', 'red');
            this.disabledSubmit = false;
            return;
          }
        } else {
          const notSize = (this.productColorSizes.length == 1 && this.productColorSizes[0].size.name == 'NOT_SIZE') ? true : false;
          if (notSize) {
            this.selectedProductColorSizeId = this.productColorSizes[0].id;
          }
        }

        if (this.quantity <= 0) {
          this.showMessage('¡Ingresar una cantidad válida!', 'red');
          this.disabledSubmit = false;
          return;
        }

        const request = {
          product_id: this.productColor.product.id,
          quantity: this.quantity,
          product_color_id: this.selectedProductColorId,
          product_color_size_id: this.selectedProductColorSizeId
        };

        axios.post(process.env.DINO.PATH.ADD_CART, request)
        .then(response => {
          const color = response.data.success ? 'green' : 'red';
          this.showMessage(response.data.message, color);
          setTimeout(() => this.disabledSubmit = false, constants.NUMBER_2000);
        })
        .catch(err => {
          this.showMessage('¡Hubo un error al añadir producto, por favor actualizar la página!', 'red');
          setTimeout(() => this.disabledSubmit = false, constants.NUMBER_2000);
        })
        .then(() => {
          CartStore.dispatch('getCartQuantity')
        });
      },

      goWhatsapp () {
        const url = window.location.href;
        const newUrl = encodeURIComponent(url);
        const urlFormat = newUrl.replace('#', '%23');
        const price = this.productColor.product.off ? this.productColor.product.sale_price : this.productColor.product.regular_price;
        const urlWhatsapp = `*DINO!* - Quiero comprar este producto.%0D%0A%0D%0A*${this.$route.params.productName.toUpperCase()}*%0D%0A*Precio:*%20S/${price}%0D%0A*URL:*%20${urlFormat}%2F%0D%0A%0D%0A_%C2%A1+Gracias+%21_`;
        return `https://api.whatsapp.com/send?phone=51987839662&text=${urlWhatsapp}`;
      }

    },
    mounted: function () {
      this.selectedProductColorId = this.$route.params.productColorId;
      this.getProductColor();
    }
  }
</script>
<style scoped>

.btn-add-cart {
  width: 100%;
  font-size: 11px !important
}

.product-name {
  width: 100%;
  height:45px;
  color:black;
  overflow:hidden;
  text-overflow: ellipsis;
}

.input-price >>> input[type='number'] {
  -moz-appearance:textfield;
  text-align: center;
}
.input-price >>> input::-webkit-outer-spin-button,
.input-price >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  text-align: center;
}

.name-product {
  word-break: normal;
}

</style>



// WEBPACK FOOTER //
// src/views/ProductDetail.vue